import { render, staticRenderFns } from "./RoomTestbankExamList.vue?vue&type=template&id=2875d289&"
import script from "./RoomTestbankExamList.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2875d289')) {
      api.createRecord('2875d289', component.options)
    } else {
      api.reload('2875d289', component.options)
    }
    module.hot.accept("./RoomTestbankExamList.vue?vue&type=template&id=2875d289&", function () {
      api.rerender('2875d289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Exam/RoomTestbankExamList.vue"
export default component.exports